import styled from 'styled-components';
import { rgba } from 'polished';
import colors from 'constants/colors';

export default styled.div`
  display: flex;
  align-items: center;

  .react-toggle-track {
    background-color: white;
    border: 2px solid ${colors.main.grey};
  }

  .react-toggle-thumb {
    width: 16px;
    height: 16px;
    top: 4px;
    left: 4px;
    background-color: ${colors.main.grey};
    border: none;
  }

  .react-toggle--checked .react-toggle-thumb {
    background-color: ${colors.main.blue};
    width: 16px;
    height: 16px;
    top: 4px;
    left: 30px;
  }
  .react-toggle--checked .react-toggle-track {
    background-color: ${rgba(colors.main.blue, 0.1)};
    border-color: ${colors.main.blue};
  }
  .react-toggle--focus .react-toggle-thumb {
    box-shadow: none;
  }
  .react-toggle--focus .react-toggle-track {
    outline: 2px solid ${colors.main.blue};
    outline-offset: 2px;
  }
  .react-toggle--checked:hover:not(.react-toggle--disabled) .react-toggle-track {
    background-color: ${rgba(colors.main.blue, 0.1)};
  }
  .react-toggle:hover:not(.react-toggle--disabled) .react-toggle-track {
    background-color: white;
  }
  .react-toggle:active:not(.react-toggle--disabled) .react-toggle-thumb {
    box-shadow: none;
  }
`;
